import { useState } from "react";
import api, { apiError } from "@/lib/api";
import Modal, { TextArea } from "@/components/Modal";
import { StarRating } from "@/components/common";
import { toast } from "sonner";

export default function ReviewModal({ targetType, targetId, subFields, onClose, onDone }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [subs, setSubs] = useState({});
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return toast.error("Veuillez donner une note");
    setBusy(true);
    try {
      await api.post("/reviews", { target_type: targetType, target_id: targetId, rating, comment, sub_ratings: subs });
      toast.success("Merci pour votre avis !");
      onDone?.();
      onClose();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <Modal title="Donner mon avis" onClose={onClose} testid="review-modal">
      <form onSubmit={submit} className="space-y-4">
        <div className="text-center">
          <p className="text-sm font-semibold text-slate-700 mb-2">Note globale</p>
          <div className="flex justify-center"><StarRating value={rating} onChange={setRating} size={32} /></div>
        </div>
        {(subFields || []).map((sf) => (
          <div key={sf.key} className="flex items-center justify-between">
            <span className="text-sm text-slate-600">{sf.label}</span>
            <StarRating value={subs[sf.key] || 0} onChange={(v) => setSubs((s) => ({ ...s, [sf.key]: v }))} size={18} />
          </div>
        ))}
        <TextArea label="Commentaire" value={comment} onChange={setComment} testid="review-comment" required={false} />
        <button disabled={busy} className="w-full bg-[#C85A32] text-white font-bold py-3 rounded-lg disabled:opacity-50" data-testid="review-submit">
          {busy ? "Envoi..." : "Publier mon avis"}
        </button>
      </form>
    </Modal>
  );
}
